import { Link } from '@tanstack/react-router'
import type { TKey } from '@/lib/i18n'

/**
 * App Store / Google Play badges linking to the home download section. Shared
 * across the feature landing pages; the labels reuse the existing
 * `site:landing.download.badge_*` copy. Render inside a `.hero-actions` or
 * `.badges` wrapper supplied by the caller.
 */
export function AppBadges(props: { t: (key: TKey) => string }) {
	const { t } = props
	return (
		<>
			<Link className='badge' hash='scarica' to='/'>
				<svg
					aria-hidden='true'
					fill='currentColor'
					height='24'
					viewBox='0 0 24 24'
					width='24'
				>
					<path d='M16.4 12.7c0-2.1 1.7-3.1 1.8-3.2-1-1.4-2.5-1.6-3-1.6-1.3-.1-2.5.8-3.2.8-.6 0-1.7-.7-2.7-.7-1.4 0-2.7.8-3.4 2-1.4 2.5-.4 6.2 1 8.3.7 1 1.5 2.1 2.5 2.1 1 0 1.4-.6 2.6-.6 1.2 0 1.5.6 2.6.6 1.1 0 1.8-1 2.4-2 .8-1.1 1.1-2.2 1.1-2.3-.1 0-2.2-.8-2.2-3.2zM14.5 6.3c.5-.7.9-1.6.8-2.5-.8 0-1.7.5-2.3 1.2-.5.6-.9 1.5-.8 2.4.9.1 1.7-.4 2.3-1.1z' />
				</svg>
				<span>
					<span className='b-sub'>
						{t('site:landing.download.badge_apple_sub')}
					</span>
					<span className='b-main'>
						{t('site:landing.download.badge_apple_main')}
					</span>
				</span>
			</Link>
			<Link className='badge' hash='scarica' to='/'>
				<svg
					aria-hidden='true'
					height='22'
					viewBox='0 0 24 24'
					width='22'
				>
					<path
						d='M3.6 2.4c-.3.3-.5.8-.5 1.4v16.4c0 .6.2 1.1.5 1.4l.1.1 9.2-9.2v-.2L3.6 2.4z'
						fill='oklch(70% 0.13 235)'
					/>
					<path
						d='M16.3 15.4l-3.1-3.1v-.2l3.1-3.1.1.1 3.6 2.1c1 .6 1 1.6 0 2.2l-3.7 2z'
						fill='oklch(78% 0.14 85)'
					/>
					<path
						d='M16.4 15.3L13.2 12l-9.2 9.2c.3.4.9.4 1.5.1l10.9-6.2z'
						fill='oklch(64% 0.2 25)'
					/>
					<path
						d='M16.4 8.7L5.5 2.5c-.6-.3-1.2-.3-1.5.1l9.2 9.2 3.2-3.1z'
						fill='oklch(72% 0.16 150)'
					/>
				</svg>
				<span>
					<span className='b-sub'>
						{t('site:landing.download.badge_google_sub')}
					</span>
					<span className='b-main'>
						{t('site:landing.download.badge_google_main')}
					</span>
				</span>
			</Link>
		</>
	)
}
